import { html } from 'fxjs/es';
import { MShopAppSolutionHomeTmplS } from '../../../Home/S/Tmpl/module/MShopAppSolutionHomeTmplS.js';
import { ButtonCheckbox } from '@services/MarppleShop/renderApp/components/atoms/ButtonCheckbox/ButtonCheckbox.ts';
import { font } from '@services/MarppleShop/shared/typography/index.ts';

export const make = (is_add) => html`
  <div class="request-of-certification">
    <div class="request-of-certification__item">
      <p>${T('report::무분별한 상품 판매 정지 또는 샵의 운영 정지')}</p>
      ${new ButtonCheckbox({
        name: 'agree',
        label: T('report::개인정보 수집 · 이용 동의'),
        font_klass: font('16_regular'),
      }).toHtmlSSR()}
    </div>
    <div class="buttons request-of-certification__buttons">
      <a id="certification-button" class="disabled">
        ${is_add ? T('report::본인 인증 후 신고 접수하기') : T('report::본인 인증 후 신고 조회하기')}
      </a>
    </div>
  </div>
`;

export const fn = () => MShopAppSolutionHomeTmplS.wrapper('list', make());
